import { createSlice } from "@reduxjs/toolkit";
import { HistoryState } from "./types";


export const initialState: HistoryState = {
    postHistory : {
      loading: false,
      error: false,
    },
    getHistory : {
      history: [],
      loading: false,
      error: false,
    }
    
};

export const historySlice: any = createSlice({
  name: "historyApi",
  initialState,
  reducers: {
    storeNews: (state) => {
      state.postHistory.loading = true;
    },
    storeSuccess: (state) => {
      state.postHistory.loading = false;
    },
    storeFailed: (state) => {
      state.postHistory.loading = false;
      state.postHistory.error = true;
    },
    getHistory: (state) => {
      state.getHistory.loading = true;
    },
    getHistorySuccess: (state, action) => {
      state.getHistory.history = action.payload;
      state.getHistory.loading = false;
    },
    getHistoryFailed: (state) => {
      state.getHistory.loading = false;
      state.getHistory.error = true;
    },
    }, 
  },
);

export const {
  storeNews,
  storeSuccess,
  storeFailed,
  getHistory,
  getHistorySuccess,
  getHistoryFailed,
} = historySlice.actions;

export default historySlice.reducer;
